import React, { useState, useEffect, useRef } from "react";
import { clsx } from "clsx";
import {useNavigationParse} from "@arctheme-hooks/useNavigationParse";
import {Collapsible} from "@src/stories/elements/Collapsible/Collapsible";

export const Accordion = ({ settings, isOpen, megamenuBlock}) => {
    const linksStyle = 'h4';

    return (
        <>
            {isOpen && megamenuBlock?.links?.length > 0 && (
                <ul className="w-full pt-8 flex flex-col gap-y-[27px]">
                    {megamenuBlock?.links?.map((subLink, subIndex) => {
                        const titleData = useNavigationParse(subLink.title);
                        return (
                            <li
                                key={subIndex}
                                className="mobile-menu-sub-item"
                            >
                                {subLink.links?.length <= 0 && (
                                    <a
                                        href={subLink.url}
                                        className={`${linksStyle} ${titleData.class} flex items-center gap-x-[8px]`}
                                    >
                                        <span className="">{titleData.text}</span>{" "}
                                        {titleData.icon && (
                                            <i className={`icon ${titleData.icon}`} />
                                        )}
                                        {subLink.links?.length > 0 && (
                                            <i className="icon icon-caret-down-thin ml-auto" />
                                        )}
                                    </a>
                                )}

                                {subLink.links?.length > 0 && (
                                    <Collapsible
                                        title={titleData.text}
                                        titleClass={`${linksStyle}`}
                                        contentClass={`${linksStyle}`}
                                        openIcon="icon-chevron-right"
                                        closeIcon="icon-caret-up-thin"
                                        iconPosition="left"
                                        desktopDisabled
                                    >
                                        <div className="flex flex-col mt-[27px] ml-[22px] gap-y-[28px]">
                                            {subLink.links.map((subSubLink, subSubIndex) => (
                                                <a
                                                    key={subSubIndex}
                                                    href={subSubLink.url}
                                                    className=""
                                                >
                                                    {subSubLink.title}
                                                </a>
                                            ))}
                                        </div>
                                    </Collapsible>
                                )}
                            </li>
                        );
                    })}
                </ul>
            )}
        </>
    );
};

export default Accordion;
